import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: "https://cdn.quasar.dev/logo-v2/svg/logo-mono-white.svg" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Midgard ")
const _hoisted_3 = { class: "row items-center no-wrap" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Profile")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Change password")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Log Out")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_toolbar_title, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_avatar, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_q_btn_dropdown, {
      color: "primary",
      "no-caps": ""
    }, {
      label: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_icon, {
            left: "",
            name: "account_circle"
          }),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.profile?.firstName) + " (" + _toDisplayString(_ctx.profile?.email) + ") ", 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_q_list, null, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              clickable: "",
              to: {name: _ctx.SessionRouteNames.PROFILE}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])), [
              [_directive_close_popup]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              clickable: "",
              to: {name: _ctx.SessionRouteNames.CHANGE_PASSWORD}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])), [
              [_directive_close_popup]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              clickable: "",
              onClick: _ctx.logOut
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_close_popup]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}